import PropTypes from 'prop-types';
export var product = PropTypes.shape({
  iconFileName: PropTypes.string,
  ProductFullName: PropTypes.string,
  ProductSymbol: PropTypes.string,
  ProductId: PropTypes.number
});